import styled from "@emotion/styled";
import PropTypes from "prop-types";

import { Image } from "../../../Image";
import styles from "./ImageBlock.style";

const ImageBlockStyled = styled.section((props) => ({ ...styles(props) }));

const ImageBlock = ({ image, imageWidth, imageHeight, className, ...rest }) => {
    if (!image) {
        return null;
    }

    return (
        <ImageBlockStyled maxWidth={imageWidth} className={className} {...rest}>
            <Image image={image} alt="" width={imageWidth} height={imageHeight} />
        </ImageBlockStyled>
    );
};

ImageBlock.propTypes = {
    image: PropTypes.string,
    imageWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    imageHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    className: PropTypes.string,
};

ImageBlock.defaultProps = {
    image: undefined,
    imageWidth: undefined,
    imageHeight: undefined,
    className: undefined,
};

export default ImageBlock;
